import { useState, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { useAuth } from "../AuthContext";
import AdminNavbar from "../Components/Navbar/AdminNavbar/AdminNavbar";
import BusinessSection from "./BusinessSection";
import CategorySection from "./CategorySection";
import Sidebar from "./Sidebar";
import ManageAdmins from "../admin/ManageAdmins";
import ManageBusinessOwners from "../admin/ManageBusinessOwners";
import "./Dashboard.css";
import { auth } from "../firebase";
import AnalyticsSection from "./AnalyticsSection";

export default function Dashboard() {
  const [active, setActive] = useState("businesses");
  const { role } = useAuth();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) return;
      await u.getIdToken(true);
      const t = await u.getIdTokenResult();
      console.log("Role:", t.claims.role);
    });
    return () => unsub();
  }, []);

  return (
    <div>
      <AdminNavbar />
      <div className="admin-dashboard">
        {/* PASS ROLE INTO SIDEBAR */}
        <Sidebar setActive={setActive} active={active} role={role} />

        <div className="admin-main">
          {active === "manageAdmins" && <ManageAdmins />}
          {active === "businesses" && <BusinessSection />}
          {active === "analytics" && role === "superadmin" && (
            <AnalyticsSection />
          )}
          {/* ONLY SUPERADMIN CAN SEE CATEGORY SECTION */}
          {active === "categories" && role === "superadmin" && (
            <CategorySection />
          )}

          {active === "businessOwners" && <ManageBusinessOwners />}

          {role === "superadmin" && (
            <div className="superadmin-section">
              <h3>Superadmin Controls</h3>
              <div className="superadmin-controls">
                <button
                  className="manage-business-btn"
                  onClick={() => setActive("businesses")}
                >
                  Manage Businesses
                </button>
                <button
                  className="manage-business-btn"
                  onClick={() => setActive("businessOwners")}
                >
                  Assign Business Owners
                </button>
                <button
                  className="manage-admins-btn"
                  onClick={() => setActive("manageAdmins")}
                >
                  Manage Admins
                </button>
                <button
                  className="manage-business-btn"
                  onClick={() => setActive("analytics")}
                >
                  Business Analytics
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
